<script>
import { required } from "vuelidate/lib/validators";
import { cloneDeep } from "lodash";
import ProcessSubtype from "@/router/views/dts/dts-modal/process-type-child.vue";
import ManageDu from "@/router/views/dts/dts-modal/process-type-du.vue";
import RawData from "@/components/widgets/raw-data.vue";
import { Carousel, Slide } from "vue-carousel";

export default {
  components: {
    ProcessSubtype,
    ManageDu,
    RawData,
    Carousel,
    Slide,
  },
  data() {
    return {
      submitted: false,
      modalTitle: "",
      tableData: [],
      filter: "",
      pageOptions: [10, 25, 50, 100],
      perPage: 10,
      currentPage: 1,
      loading: false,
      form: {
        officeId: this.$store.state.data.selectedDU.id,
        processName: "",
        easeOfDoingBusinessType: "",
        estimatedWorkingDays: "",
        daysToRemindOfficeProcessor: "",
        parentProcessTypeId: 0,
        targetCustomer: "",
        category: "",
      },
      easeOfDoingBusiness: null,
      easeOfDoingBusinessOptions: [
        {
          option: "Simple Process",
          easeOfDoingBusinessType: "Simple Process",
          estimatedWorkingDays: "3",
          daysToRemindOfficeProcessor: "2",
        },
        {
          option: "Complex Process",
          easeOfDoingBusinessType: "Complex Process",
          estimatedWorkingDays: "7",
          daysToRemindOfficeProcessor: "6",
        },
        {
          option: "Highly Technical Process",
          easeOfDoingBusinessType: "Highly Technical Process",
          estimatedWorkingDays: "20",
          daysToRemindOfficeProcessor: "19",
        },
        {
          option: "Highly Technical/Discretional Process",
          easeOfDoingBusinessType: "Highly Technical/Discretional Process",
          estimatedWorkingDays: "20",
          daysToRemindOfficeProcessor: "19",
        },
        {
          option: "Others",
          easeOfDoingBusinessType: "",
          estimatedWorkingDays: "",
          daysToRemindOfficeProcessor: "",
        },
      ],
      campuses: [],
      dus: [],
      requirements: [],
      addNewReq: false,
      req: {
        id: 0,
        processTypeId: 0,
        order: 0,
        requirements: "",
        whereToSecure: "",
      },
      reqLoading: false,
      searchReq: "",
      slideNum: 1,
      reportList: false,
    };
  },
  validations: {
    form: {
      processName: { required },
      easeOfDoingBusinessType: { required },
      estimatedWorkingDays: { required },
      daysToRemindOfficeProcessor: { required },
      processOwnerId: { required },
      targetCustomer: { required },
    },
    req: {
      requirements: { required },
      whereToSecure: { required },
    },
  },
  computed: {
    filtered() {
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (item.processName) {
            if (
              item.processName.toUpperCase().includes(this.filter.toUpperCase())
            )
              return item.processName
                .toUpperCase()
                .includes(this.filter.toUpperCase());
          }
          if (item.easeOfDoingBusinessType) {
            if (
              item.easeOfDoingBusinessType
                .toUpperCase()
                .includes(this.filter.toUpperCase())
            )
              return item.easeOfDoingBusinessType
                .toUpperCase()
                .includes(this.filter.toUpperCase());
          }
        });
      }
      return data.sort(function (a, b) {
        if (a.processName < b.processName) {
          return -1;
        }
        if (a.processName > b.processName) {
          return 1;
        }
        return 0;
      });
    },
    paginated() {
      let data = this.filtered;
      var total = this.currentPage * this.perPage;
      var currentData = data.slice(total - this.perPage, total);
      if (this.currentPage > 1 && currentData.length == 0) {
        total = (this.currentPage - 1) * this.perPage;
        currentData = data.slice(total - this.perPage, total);
      }
      return currentData;
    },
    rows() {
      return this.filtered.length;
    },
  },
  // async created() {
  //   await this.getData();
  // },
  methods: {
    async getCampuses() {
      await this.$store
        .dispatch("campus/GetCampus")
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.campuses = res.data;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast("Something went wrong - Campuses!", "error");
          }
        });
    },
    async getData() {
      this.loading = true;
      await this.$store
        .dispatch("dtsprocesstype/GetProcessType")
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          res.data.forEach((x) => {
            x.showStep = false;
            x.showSubtype = false;
            x.loadStep = false;
            x.steps = [];
          });
          this.tableData = res.data.reverse();
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast("Something went wrong - Process Types!", "error");
          }
        });
      await this.getCampuses();
      this.loading = false;
    },
    onSearch() {
      this.tableData.forEach((x) => {
        x.showSubtype = false;
      });
    },
    onSubmit(form) {
      let data = cloneDeep(form);
      data.category = form.category.length ? form.category.join(", ") : "";
      if (data.id) {
        this.$store
          .dispatch("dtsprocesstype/UpdateProcessType", data)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            var index = this.tableData.findIndex((item) => item.id == data.id);
            this.tableData.splice(index, 1, data);
            this.$bvModal.hide("process-type-modal");
            this.showToast("Successfully updated!", "success");
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      } else {
        this.$store
          .dispatch("dtsprocesstype/CreateProcessType", data)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            res.data.showSubtype = false;
            this.tableData.push(res.data);
            this.$bvModal.hide("process-type-modal");
            this.$emit("show-req-step", res.data);
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      }
    },
    addProcessType() {
      this.$emit("addProcessType");
    },
    updateProcessType(props) {
      this.form = cloneDeep(props);
      this.form.parentProcessTypeId = !props.parentProcessTypeId
        ? 0
        : props.parentProcessTypeId;
      this.form.estimatedWorkingDays =
        this.form.estimatedWorkingDays.toString();
      this.form.daysToRemindOfficeProcessor =
        this.form.daysToRemindOfficeProcessor.toString();
      this.easeOfDoingBusiness = {
        option:
          this.form.easeOfDoingBusinessType == "Simple Process"
            ? "Simple Process"
            : this.form.easeOfDoingBusinessType == "Complex Process"
            ? "Complex Process"
            : this.form.easeOfDoingBusinessType == "Highly Technical Process"
            ? "Highly Technical Process"
            : this.form.easeOfDoingBusinessType ==
              "Highly Technical/Discretional Process"
            ? "Highly Technical/Discretional Process"
            : "Others",
        easeOfDoingBusinessType:
          this.form.easeOfDoingBusinessType == "Simple Process"
            ? "Simple Process"
            : this.form.easeOfDoingBusinessType == "Complex Process"
            ? "Complex Process"
            : this.form.easeOfDoingBusinessType == "Highly Technical Process"
            ? "Highly Technical Process"
            : this.form.easeOfDoingBusinessType ==
              "Highly Technical/Discretional Process"
            ? "Highly Technical/Discretional Process"
            : this.form.easeOfDoingBusinessType,
        estimatedWorkingDays: this.form.estimatedWorkingDays.toString(),
        daysToRemindOfficeProcessor:
          this.form.daysToRemindOfficeProcessor.toString(),
      };
      if (props.category && props.category.length) {
        this.form.category = props.category.split(", ");
      }
      this.$emit("updateProcessType", {
        form: this.form,
        easeOfDoingBusiness: this.easeOfDoingBusiness,
      });
      // this.modalTitle = "Update Process Type";
      // this.$bvModal.show("modal-create-processType");
    },
    deleteProcessType(props) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("dtsprocesstype/DeleteProcessType", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var index = this.tableData.findIndex(
                (item) => item.id == props.id
              );
              this.tableData.splice(index, 1);
              this.showToast("Successfully deleted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    onReset() {
      this.submitted = false;
      this.form = {
        officeId: this.$store.state.data.selectedDU.id,
        processName: "",
        processDescription: "",
        easeOfDoingBusinessType: "",
        estimatedWorkingDays: "",
        daysToRemindOfficeProcessor: "",
        parentProcessTypeId: 0,
        targetCustomer: "",
        category: "",
      };
      this.easeOfDoingBusiness = null;
    },
    showSubtype(props) {
      props.showSubtype = !props.showSubtype;
      if (props.showSubtype) props.showStep = false;
      this.$refs[`processSubtype-${props.id}`][0].getData(props);
    },
    manageOffices(props) {
      this.$refs.managedu.getDU(props);
      this.$bvModal.show("modal-processDu");
    },
    easeOfDoingBusinessLabel({ option }) {
      return `${option}`;
    },
    selecteaseOfDoingBusiness() {
      this.form.easeOfDoingBusinessType =
        this.easeOfDoingBusiness.easeOfDoingBusinessType != "Others"
          ? this.easeOfDoingBusiness.easeOfDoingBusinessType
          : "";
      this.form.estimatedWorkingDays =
        this.easeOfDoingBusiness.estimatedWorkingDays;
      this.form.daysToRemindOfficeProcessor =
        this.easeOfDoingBusiness.daysToRemindOfficeProcessor;
      this.$forceUpdate();
    },
    async getDus($event) {
      let id = $event.target.value;
      this.dus = [];
      this.form.processOwnerId = "";
      await this.$store
        .dispatch("deliveryunit/GetDeliveryUnitByCampus", id)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.dus = res.data;
        })
        .catch((err) => {
          this.showToast("Cannot be deleted!", "error");
        });
    },
    async showReqs(row) {
      this.selectedProcessType = row;
      this.modalTitle = "Process Type Requirements";
      this.$bvModal.show("modal-requirements");
    },
    showDetails(row) {
      this.$emit("show-req-step", row);
    },
    printProcessType(type) {
      if (type) {
        this.$emit("print-process-type", {
          type: type,
          data: [this.form.processOwnerId],
        });
      } else {
        this.$emit("print-process-type", {
          type: null,
          data: [],
        });
      }
    },
    async showStep(props) {
      props.showStep = !props.showStep;
      if (props.showStep) {
        props.showSubtype = false;
        props.loadStep = true;
        await this.getSteps(props);
        props.loadStep = false;
      }
    },
    goToSelection() {
      this.slideNum = 2;
      this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
    },
    goBackToSelection() {
      this.slideNum = 1;
      this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
    },
  },
};
</script>
<template>
  <div class="ps-2 py-2" style="min-width: 950px">
    <!-- Main -->
    <div class="d-flex align-items-center justify-content-between mb-2">
      <h5 class="mb-0">List of Process Types</h5>
      <div class="d-flex">
        <button
          type="button"
          class="btn btn-sm btn-purple d-flex align-items-center me-1"
          :id="`select-report`"
          @click="reportList = true"
        >
          <i class="bx bx-printer fs-6 me-1"></i>Print Process Types
        </button>
        <b-popover
          :target="`select-report`"
          triggers="click"
          placement="left"
          :show.sync="reportList"
          custom-class="popover-report"
        >
          <template v-slot:title>
            <div class="d-flex align-items-center justify-content-between">
              <small>Print Process Types</small>
              <span
                class="bx bx-x font-size-14 cursor-pointer"
                @click="reportList = false"
              ></span>
            </div>
          </template>
          <carousel
            ref="carousel"
            class="events navs-carousel custom-carousel"
            id="timeline-carousel"
            :navigation-enabled="false"
            :pagination-enabled="false"
            :perPage="1"
            :autoplay="false"
            :minSwipeDistance="0"
            :mouseDrag="false"
          >
            <slide>
              <div v-if="slideNum == 1">
                <div>
                  <a
                    href="javascript:void(0);"
                    @click="printProcessType(null)"
                    class="font-size-12 text-dark hoverable-link"
                    >All</a
                  >
                </div>
                <hr class="my-1" />
                <div>
                  <a
                    href="javascript:void(0);"
                    @click="goToSelection"
                    class="font-size-12 text-dark hoverable-link"
                    >By Owner</a
                  >
                </div>
              </div>
            </slide>
            <slide>
              <div v-if="slideNum == 2">
                <a
                  href="javascript:void(0);"
                  class="text-primary d-flex align-items-center"
                  @click="goBackToSelection"
                  ><i class="bx bx-left-arrow-alt me-1"></i>Go back to
                  selection</a
                >
                <div class="mb-3 mt-2">
                  <label for="campus" class="mb-1">{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}</label>
                  <select
                    id="campus"
                    v-model="form.campusId"
                    class="form-control form-select"
                    @change="getDus"
                  >
                    <option value="0"></option>
                    <option
                      v-for="(campus, index) in campuses"
                      :key="index"
                      :value="campus.id"
                    >
                      {{ campus.campusName }}
                    </option>
                  </select>
                </div>
                <b-collapse :visible="form.campusId != 0">
                  <div v-if="form.campusId != 0">
                    <div class="mb-3">
                      <label for="office">Process Owner</label>
                      <select
                        id="office"
                        v-model="form.processOwnerId"
                        class="form-control form-select"
                        :class="{
                          'is-invalid':
                            submitted && $v.form.processOwnerId.$error,
                        }"
                      >
                        <option value="0"></option>
                        <option
                          v-for="(du, index) in dus"
                          :key="index"
                          :value="du.id"
                        >
                          {{ du.name }}
                        </option>
                      </select>
                      <div
                        v-if="submitted && $v.form.processOwnerId.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.form.processOwnerId.required"
                          >This value is required.</span
                        >
                      </div>
                    </div>
                  </div>
                </b-collapse>
                <div class="d-flex">
                  <button
                    type="submit"
                    class="btn btn-sm btn-block btn-purple"
                    @click="printProcessType('du')"
                  >
                    Print Report
                  </button>
                </div>
              </div>
            </slide>
          </carousel>
        </b-popover>
        <button
          type="button"
          @click="addProcessType"
          class="btn btn-sm btn-success d-flex align-items-center ms-1"
        >
          <i class="bx bx-plus fs-6 me-1"></i>Create Process Type
        </button>
      </div>
    </div>
    <div class="d-flex flex-row-reverse mb-3">
      <div class="d-flex align-items-center">
        <div id="tickets-table_filter" class="dataTables_filter me-1">
          <label class="d-inline-flex align-items-center mb-0">
            <b-form-input
              autocomplete="off"
              v-model="filter"
              type="search"
              placeholder="Search Process Type..."
              class="form-control"
              @input="onSearch()"
            ></b-form-input>
          </label>
        </div>
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center mb-0">
            <b-form-select
              class="form-select"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
            >
            </b-form-select>
          </label>
        </div>
      </div>
    </div>
    <b-card v-if="loading">
      <div class="d-flex align-items-center justify-content-center">
        <div class="preloader-component me-2">
          <div class="status">
            <div class="spinner-chase w-25px h-25px">
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
            </div>
          </div>
        </div>
        <h5 class="mb-0">Loading...</h5>
      </div>
    </b-card>
    <b-card class="text-center" v-else-if="paginated.length == 0">
      <div v-if="filter != ''">
        <i class="fas fa-exclamation-triangle me-2"></i>There are no items
        matching your request
      </div>
      <div v-else>
        <i class="fas fa-exclamation-triangle me-2"></i>No items available
      </div>
    </b-card>
    <div v-else class="text-muted">
      <b-card no-body class="m-0 mb-3">
        <b-card-header>
          <div class="d-flex justify-content-between">
            <div>
              <b>Name</b>
            </div>
            <div class="d-flex align-items-center">
              <div style="width: 220px">
                <b>Created By</b>
              </div>
              <div style="width: 200px">
                <b>Ease of Doing Business</b>
              </div>
              <div style="width: 180px">
                <b>Duration</b>
              </div>
              <div style="width: 60px" class="text-end">
                <b>Actions</b>
              </div>
            </div>
          </div>
        </b-card-header>
      </b-card>
      <div role="tablist" v-for="(x, index) in paginated" :key="x.id">
        <div class="position-relative ms-1">
          <RawData
            :data="x"
            v-if="$store.state.decrypt.isAdmin()"
            :style="`z-index: ${paginated.length - index + 11}`"
          />
        </div>
        <b-card
          no-body
          class="m-0 mb-3 py-1"
          :style="`z-index: ${paginated.length - index + 10}`"
        >
          <b-card-header>
            <div class="d-flex justify-content-between">
              <div class="pe-3">
                <div>{{ x.processName }}</div>
                <small class="text-warning">{{ x.processOwner }}</small>
                <div class="d-flex align-items-center">
                  <small
                    ><a
                      href="javascript: void(0);"
                      class="text-green d-flex align-items-center"
                      @click="showSubtype(x)"
                    >
                      {{ x.showSubtype ? "Hide" : "Show" }}
                      Subtype
                      <i
                        class="bx bx-chevron-right rotate font-size-14"
                        :class="{
                          'rotate-90': x.showSubtype,
                        }"
                      ></i>
                    </a>
                  </small>
                  <span class="mx-1">|</span>
                  <small
                    ><a
                      href="javascript: void(0);"
                      class="text-info d-flex align-items-center"
                      @click="showDetails(x)"
                    >
                      Show Details
                    </a>
                  </small>
                  <!-- <span class="mx-2">|</span>
                  <small
                    ><a
                      href="javascript: void(0);"
                      class="text-yellow d-flex align-items-center"
                      @click="showStep(x)"
                    >
                      {{ x.showStep ? "Hide" : "Show" }}
                      Step
                      <i
                        class="bx bx-chevron-right rotate font-size-14"
                        :class="{
                          'rotate-90': x.showStep,
                        }"
                      ></i>
                    </a>
                  </small> -->
                </div>
              </div>
              <div class="d-flex">
                <div style="width: 220px" class="pe-3">
                  <div v-if="x.addedByOffice">
                    <div>{{ x.addedByOffice.name }}</div>
                    <small>{{ x.addedByOffice.campus }}</small>
                  </div>
                  <div v-else>Admin</div>
                </div>
                <div style="width: 200px" class="pe-3">
                  {{ x.easeOfDoingBusinessType }}
                </div>
                <div style="width: 180px" class="pe-3">
                  <small
                    >Estimated Working Days:
                    <b class="text-info">{{ x.estimatedWorkingDays }}</b></small
                  >
                  <br />
                  <small
                    >Days to Remind Processor:
                    <b class="text-warning">{{
                      x.daysToRemindOfficeProcessor
                    }}</b></small
                  >
                </div>
                <div style="width: 60px">
                  <div class="d-flex justify-content-end">
                    <i
                      class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2"
                      :id="`process-popover-${x.id}`"
                      tabindex="0"
                    ></i>
                    <b-popover
                      :target="`process-popover-${x.id}`"
                      triggers="click blur"
                      placement="leftbottom"
                      variant="secondary"
                      custom-class="p-0"
                    >
                      <b-list-group class="w-100 fit">
                        <b-list-group-item
                          button
                          action
                          class="d-flex align-items-center text-success"
                          @click="manageOffices(x)"
                          ><i class="bx bx-building font-size-18 me-1"></i
                          >Manage Office Access</b-list-group-item
                        >
                        <b-list-group-item
                          button
                          action
                          class="d-flex align-items-center text-info"
                          @click="updateProcessType(x)"
                          ><i class="bx bx-edit font-size-18 me-1"></i>Update
                          Process Type</b-list-group-item
                        >
                        <b-list-group-item
                          button
                          action
                          class="d-flex align-items-center text-danger"
                          @click="deleteProcessType(x)"
                          ><i class="bx bx-trash font-size-18 me-1"></i>Delete
                          Process Type</b-list-group-item
                        >
                      </b-list-group>
                    </b-popover>
                  </div>
                </div>
              </div>
            </div>
          </b-card-header>
        </b-card>
        <ProcessSubtype
          :ref="`processSubtype-${x.id}`"
          :parentId="x.id"
          :showSubtype="x.showSubtype"
          @manageOffices="manageOffices($event)"
        ></ProcessSubtype>
      </div>
    </div>
    <div class="row">
      <div v-if="rows > 0" class="col">
        Showing {{ (currentPage - 1) * perPage + 1 }} -
        {{
          rows > (currentPage - 1) * perPage + perPage
            ? (currentPage - 1) * perPage + perPage
            : rows
        }}
        of {{ rows }}
      </div>
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0" style="z-index: -1">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
    <ManageDu ref="managedu"></ManageDu>
  </div>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}
</style>